export const documentUseCode = {
  CDA_ORDER: 'CDA_ORDER'
}
